import clsx from 'clsx'
import styles from './App.module.css'
import disableScroll from 'disable-scroll'
import Ligne from './Components/Ligne/Ligne'
import Titre from './Components/Titre/Titre'
import Buttons from './Components/Buttons/Buttons'
import Password from './Components/Password/Password'
import React, {
  useEffect
} from 'react'
import {
  Card,
  CardContent
} from '@mui/material'
import {
  isMobile
} from 'react-device-detect'
import {
  get_password
} from './Functions/Functions'
import {
  settings
} from './Variables/Variables'

function App() {
  const [state, setState] = React.useState(settings)
  const [password, setPassword] = React.useState(get_password(settings))
  const Update = (value, type, update = false) => {
    const object = {
      ...state,
      [type]: value
    }
    setState(object)
    if (update) {
      setPassword(get_password(object))
    }
  }
  useEffect(() => {
    disableScroll.on()
    const disablePinchZoom = (event) => {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    }
    document.addEventListener('touchmove', disablePinchZoom, {
      passive: false
    })
    return () => {
      document.removeEventListener('touchmove', disablePinchZoom)
    }
  }, [])
  return (
    <Card
      className={
        clsx({
          [styles.card]: true,
          [styles.container]: true,
          [styles.mobile]: isMobile
        })
      }
    >
      <Titre state={state}/>
      <CardContent className={styles.content}>
        <Ligne
          target="n"
          state={state}
          Update={Update}
          label="Chiffres"
        />
        <Ligne
          target="l"
          state={state}
          Update={Update}
          label="Minuscules"
        />
        <Ligne
          target="u"
          state={state}
          Update={Update}
          label="Majuscules"
        />
        <Ligne
          target="s"
          state={state}
          Update={Update}
          label="Symboles"
        />
        <Password password={password}/>
        <Buttons
          state={state}
          password={password}
          setPassword={setPassword}
        />
      </CardContent>
    </Card>
  )
}

export default App
